/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 31/3/2023
 */

import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent } from "@mui/material";
import { closeOfferModal } from "../../Store/Slices/offerSlice";
import AddOffer from "./AddOffer";
import EditOffer from "./EditOffer";
import DeleteOffer from "./DeleteOffer";

const OfferDialog = () => {
  const dispatch = useDispatch();
  const offer = useSelector((state) => state.offer);

  let content;
  let deleteView = false;

  const roles = sessionStorage.getItem("roles");

  const handleClose = () => {
    dispatch(closeOfferModal(false));
  };

  if (offer.modalStatus === "add") {
    content = roles?.split(",").includes("PRIV_ES_ADD_OFFER") ? <AddOffer handleClose={() => handleClose()} /> : null;
  } else if (offer.modalStatus === "edit") {
    content =  roles?.split(",").includes("PRIV_ES_EDIT_OFFER") ? <EditOffer handleClose={() => handleClose()} /> : null;
  } else if (offer.modalStatus === "delete") {
    deleteView = true;
    content = roles?.split(",").includes("PRIV_ES_DELETE_OFFER") ? <DeleteOffer /> : null;
  }

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={deleteView ? "xs" : "md"}
        open={
          offer.modalStatus === "add" ||
          offer.modalStatus === "edit" ||
          offer.modalStatus === "delete"
        }
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>{content}</DialogContent>
      </Dialog>
    </>
  );
};

export default OfferDialog;
